import * as React from "react";

const NeatcarButton = (
  {
    disabled,
    type,
    title,
    onClick = () => {},
    inverse = false,
    gray = false,
    className,
    icon,
    loading,
  }) => {

  let style = ' border-transparent text-white bg-neatcar';

  if (inverse) {
    style = ' text-neatcar bg-white border-neatcar'
  }
  if (gray) {
    style = ' border-transparent text-neatcar bg-neatcarBackground'
  }

  if (disabled) {
    style += ' opacity-30 hover:opacity-30';
  }
  if (className) {
    style += ` ${className}`;
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={"w-full min-h-10 flex justify-center py-2 px-3 sm:px-4 items-center border rounded-3xl shadow-sm text-xs sm:text-sm font-medium hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neatcar whitespace-nowrap active:scale-95 transition-transform" + style}
    >
      {icon && <img src={icon} width={'12'} height={'18'} className={'mr-1 sm:mr-2 w-3 h-[1.125rem]'} alt={title}/>}
      {title}
    </button>
  );
}

export default NeatcarButton;
